import React, { Component } from 'react';
import styled from 'styled-components';

import CloseIcon from '../CloseIcon';

class CrossButton extends Component {
    render() {
        const { onClick = null, className } = this.props;
        return (
            <Root onClick={onClick} className={className}>
                <CloseIconStyled />
            </Root>
        );
    }
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    -webkit-tap-highlight-color: rgba(0,0,0,0);
`;

const CloseIconStyled = styled(CloseIcon)`
    stroke: #000000;

    :hover {
        stroke: #0032A0;
    }

    :active {
        stroke: #002679;
    }
`;

export default CrossButton;
